import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-GISsales',
    templateUrl: './GISsales.component.html',
    styleUrls: ['./GISsales.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class GISsalesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
